export const TIP_CONTENT = `购房人通过房协网报名登记后产生的号码为“购房登记号"【样式为14位数字号码：2019XXXXXXXXXX]。
房屋行政管理部门复核后的名册中的“公证摇号编号”为第一位带有字母的号码【棚改货币化安置住户登记购房人的“公证摇号编号''：A+数字，刚需家庭登记购房人的“公证摇号编号” 为：B+数字；普通家庭登记购房人的“公证摇号编号”为：C+ 数字】，该“公证摇号编号”是导入公证机构摇号的原始号码，公证摇号即对该摇号编号进行排序，排序生成的顺序号即为 “选房顺序号”。
查询“选房顺序号”需要提前知晓购房人“购房登记号''对应的“公证摇号编号”。`